/**
 * iconRegistry.js — ELYON-SHELL-FOUNDATION-1
 *
 * Maps Lucide icon name strings (as declared in module manifests) to
 * React components. Imported by Sidebar.jsx for dynamic module icon rendering.
 *
 * SIDEBAR-IMPORT-GATE: every icon name listed here MUST resolve at import time.
 * Verified against lucide-react ^1.8.0. Zero ReferenceErrors on render.
 *
 * To add a new module icon: add an entry here — do NOT add the import
 * directly to Sidebar.jsx (keeps Sidebar.jsx's import clean and gate-checkable).
 */
import {
  Monitor,
  Truck,
  Brain,
  Globe,
  Headphones,
  Users,
  ShoppingCart,
  Warehouse,
  Package,
  Fuel,
  BarChart3,
  FileText,
  Navigation,
  MessageSquare,
  Server,
  Car,
  Cpu,
  Settings,
  LayoutGrid,
  Layers,
  Boxes,
  Network,
  Radio,
  Eye,
  MapPin,
  LayoutDashboard,
  Bell,
  Sliders,
  Plug,
} from 'lucide-react';

/**
 * Maps the icon string from a module manifest to a Lucide React component.
 * Fallback: LayoutGrid (generic module placeholder).
 *
 * @param {string} iconName - The icon name from the module manifest.
 * @returns {import('lucide-react').LucideIcon} Lucide icon component.
 */
export function resolveModuleIcon(iconName) {
  return ICON_REGISTRY[iconName] ?? LayoutGrid;
}

/** Full registry of supported module icons. */
export const ICON_REGISTRY = {
  Monitor,
  Truck,
  Brain,
  Globe,
  Headphones,
  Users,
  ShoppingCart,
  Warehouse,
  Package,
  Fuel,
  BarChart3,
  FileText,
  Navigation,
  MessageSquare,
  Server,
  Car,
  Cpu,
  Settings,
  LayoutGrid,
  Layers,
  Boxes,
  Network,
  Radio,
  Eye,
  MapPin,
  LayoutDashboard,
  Bell,
  Sliders,
  Plug,
};
